// Shared algorithm, mirrored for the two independently deployed frontends.
// Keep every price. Try nearby free positions before allowing overlap at low zoom.
export function layoutPriceLabels(points, width, height) {
  const cells = new Map();
  const size = 96;
  const key = (x, y) => `${x},${y}`;
  const slots = (box) => {
    const keys = [];
    for (let x = Math.floor(box.left / size); x <= Math.floor(box.right / size); x++) {
      for (let y = Math.floor(box.top / size); y <= Math.floor(box.bottom / size); y++) keys.push(key(x, y));
    }
    return keys;
  };
  const intersects = (a, b) => a.left < b.right + 3 && a.right + 3 > b.left && a.top < b.bottom + 3 && a.bottom + 3 > b.top;
  return points.map((point) => {
    const w = point.width, h = 21;
    const offsets = [[0, -18], [0, -43], [0, 18], [-w - 4, -18], [w + 4, -18], [-w - 4, 18], [w + 4, 18]];
    let chosen;
    for (const [dx, dy] of offsets) {
      const left = Math.round(point.x - w / 2 + dx), top = Math.round(point.y - h / 2 + dy);
      const box = { left, top, right: left + w, bottom: top + h };
      if (box.left < 2 || box.right > width - 2 || box.top < 2 || box.bottom > height - 2) continue;
      if (!slots(box).some((slot) => cells.get(slot)?.some((other) => intersects(box, other)))) { chosen = box; break; }
    }
    // No hidden markers and no clusters: fully opaque labels can overlap only
    // when the viewport genuinely has no room left for all prices.
    if (!chosen) {
      const left = Math.max(2, Math.min(width - w - 2, Math.round(point.x - w / 2)));
      const top = Math.max(2, Math.min(height - h - 2, Math.round(point.y - h / 2 - 18)));
      chosen = { left, top, right: left + w, bottom: top + h };
    }
    for (const slot of slots(chosen)) {
      if (!cells.has(slot)) cells.set(slot, []);
      cells.get(slot).push(chosen);
    }
    return { ...point, ...chosen };
  });
}
